import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SEARCH_TYPES, SEARCH_TABS_RESULT, ISort } from '../models';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { IStore } from 'reducers/index';
import { ISortModel } from 'reducers/filters/models';
import { setSort, resetSort } from 'actions/filters';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { isEmptyError } from 'utilities/validate';
import { fetchEquipments, resetEquipments } from 'actions/equipments';
import { displayFilters } from 'actions/filters';
import { setSortForTable } from 'utilities/tables';
import { FiltersInput } from 'modules/filters/components/FiltersInput';
import { FiltersDateInput } from 'modules/filters/components/FiltersDateInput';
import InPageDialog from '../../../../components/page-dialog';
import { Filters } from 'modules/filters/containers/Filters';
import { IEquipments } from 'reducers/equipments/models';
import { TabComponent } from 'components/sub-navigation/components/TabComponent';
import { EQCols } from './models';
import { GeneralTable } from 'modules/search/components/GeneralTable';
import { Search } from '../Search';
interface IMapDispatchToProps {
    fetchEquipments: (pageNumber: number, pageSize: number, genericFilter: string) => Promise<void>;
    setSort: (sort: ISortModel) => void;
    resetSort: () => void;
    displayFilters: (hideFilters: boolean, target: string) => void;
    resetEquipments: () => void;
}

interface IMapStateToProps {
    isFetchSearchDataLoading: boolean;
    isFetchSearchDataError: boolean;
    searchPendingError: string | string[],
    equipments: IEquipments | any;
}
interface IProps extends RouteComponentProps, IMapStateToProps, IMapDispatchToProps { }

interface IState {
    sorted: any[] | ISort[];
    genericFilter: string;
    page: number;
    pageSize: number;
    totalCount: number;
    clearFilters: boolean,
    isFetchinProgress: boolean;
    pendingError: string | string[];
    etaFrom: boolean,
    etdFrom: boolean,
    typeOfSearch: string,
    equipment: any[],
    triggerChange: any;
    shouldClear: boolean;
    showDialog: boolean;
    hasData: boolean;
    errorMsg: string | null
}
export class _SearchEquipment extends Component<IProps, IState>{
    public generalInputRef: any = React.createRef();
    public tableRef: any = React.createRef();
    public state = {
        sorted: [],
        genericFilter: '',
        page: 1,
        pageSize: 10,
        totalCount: 0,
        isFetchinProgress: true,
        etaFrom: false,
        etdFrom: false,
        pendingError: '',
        typeOfSearch: SEARCH_TYPES.EQUIPMENT,
        equipment: [],
        clearFilters: false,
        triggerChange: null,
        shouldClear: false,
        showDialog: false,
        hasData: false,
        errorMsg: ''
    };
    constructor(props: any) {
        super(props);
    }
    public componentDidMount() {
        this.props.displayFilters(false, 'jobCostingFiltersEquipment')
        this.setState({
            triggerChange: {},
            isFetchinProgress: false,
        })
    }
    public componentDidUpdate(props: any, state: any) {
        if (this.props.isFetchSearchDataError !== props.isFetchSearchDataError) {
            this.setState({
                showDialog: this.props.isFetchSearchDataError,
                isFetchinProgress: false,
                errorMsg: this.props.searchPendingError.toString() ? this.props.searchPendingError.toString() : 'Request Error'
            })
            if (this.props.location.search) {
                this.props.history.push(this.props.location.pathname);
            }
        }
        if (this.props.equipments !== props.equipments) {
            this.setData(this.props.equipments.result, this.props.equipments.page, this.props.equipments.pageSize, this.props.equipments.totalCount)
            this.setState({
                totalCount: this.props.equipments.totalCount
            })
            if (this.props.location.search) {
                this.props.history.push(this.props.location.pathname);
            }
        }
        if (this.props.searchPendingError !== props.searchPendingError &&
            this.props.isFetchSearchDataError === true) {
            const error = isEmptyError(this.props.searchPendingError, 'Server error');
            this.setState({
                pendingError: error,
                isFetchinProgress: false,
                hasData: false
            })
            if (this.props.location.search) {
                this.props.history.push(this.props.location.pathname);
            }
        }
    }

    public componentWillUnmount(){
        this.props.resetSort()
    }
    
    public render() {
        return (
            <Search triggerFetch={() => this.targetFetch()}>
                <InPageDialog
                    showDialog={this.state.showDialog}
                    type={'error'}
                    message={this.state.errorMsg}
                    closeMethod={() => this.setState({ showDialog: false, errorMsg: '' })} />
                <Filters
                    tableNameKey="jobCostingFiltersEquipment"
                    requireFilters={true}
                    genericFilter={this.state.genericFilter}
                    fetchFunction={() => this.fetchReset()}
                    filters={[
                        <FiltersInput
                            key="equipmentNumber"
                            name="equipmentNumber"
                            label="Equipment Number"
                            id={'equipmentNumber'}
                        />,
                        <FiltersInput
                            key="clrNumber"
                            name="clrNumber"
                            label="CLR Number"
                            id={'clrNumber'}
                        />,
                        <FiltersInput
                            key="loadingPort"
                            name="loadingPort"
                            id="loadingPort"
                            label="Loading port"
                        />,
                        <FiltersInput
                            key="dischargePort"
                            name="dischargePort"
                            id="dischargePort"
                            label="Discharge port"
                        />,
                        <FiltersInput
                            key="carrierBookingNumber"
                            name="carrierBookingNumber"
                            id="carrierBookingNumber"
                            label="Carrier booking Number"
                        />,
                        <FiltersInput
                            key="consigneeBECode"
                            name="consigneeBECode"
                            id="consigneeBECode"
                            label="Consignee (BE Code)"
                        />,
                        <FiltersInput
                            key="shipperBECode"
                            name="shipperBECode"
                            id="shipperBECode"
                            label="Shipper (BE Code)"
                        />,
                        <FiltersInput
                            key="carrier"
                            name="carrier"
                            id="carrier"
                            label="Carrier"
                        />,
                        <FiltersDateInput
                            key="etdFrom"
                            name="etdFrom"
                            id="etdFrom"
                            label="ETD (From)"
                            relatedField="etdTo"
                            setValidity={(val: any) => this.setState({ etdFrom: val })}
                            isInvalid={this.state.etdFrom}
                            type="dateFromTo"
                            withTime={false}
                        />,
                        <FiltersDateInput
                            key="etdTo"
                            name="etdTo"
                            id="etdTo"
                            label="ETD (to)"
                            minValue="etdFrom"
                            setValidity={(val: any) => this.setState({ etdFrom: val })}
                            isInvalid={this.state.etdFrom}
                            type="dateFromTo"
                            withTime={false}
                        />,
                        <FiltersDateInput
                            key="etaFrom"
                            name="etaFrom"
                            id="etaFrom"
                            label="ETA (From)"
                            relatedField="etaTo"
                            setValidity={(val: any) => this.setState({ etaFrom: val })}
                            isInvalid={this.state.etaFrom}
                            type="dateFromTo"
                            withTime={false}
                        />,
                        <FiltersDateInput
                            key="etaTo"
                            name="etaTo"
                            id="etaTo"
                            label="ETA (to)"
                            minValue="etaFrom"
                            setValidity={(val: any) => this.setState({ etaFrom: val })}
                            isInvalid={this.state.etaFrom}
                            type="dateFromTo"
                            withTime={false}
                        />,
                    ]}
                    resetErrors={() => this.resetDates()}
                    disableSubmit={this.state.etaFrom || this.state.etdFrom}
                    resetPaging={(pageNumber: any, pageSize: any) => {
                        if (this.tableRef && this.tableRef.current && this.tableRef.current.querySelector('input[type=number]')) {
                            this.tableRef.current.querySelector('input[type=number]').value = 1
                        }
                        this.setState({
                            page: 1,
                            totalCount: 0,
                            equipment: [],
                            clearFilters: false,
                            hasData: false
                        })
                    }}
                />
                <TabComponent name="search-results" activeTab={0} navLinks={[SEARCH_TABS_RESULT()[4]]}>
                    <GeneralTable
                        id="jobCosting-search-equipment"
                        cols={EQCols}
                        data={this.state.equipment}
                        pageCount={Math.ceil(this.props.equipments.totalCount / this.state.pageSize)}
                        isLoading={this.props.isFetchSearchDataLoading}
                        fetchData={this.justFetch}
                        linkAction={(e: any) => {
                            const getId = e.id;
                            const url = `/job-costing/equipments/${getId}`;
                            this.linkAction(url)
                        }}
                        refFwd={null}
                    />
                </TabComponent>
            </Search>
        );
    }
    private setData = (data: any, page: number, pageSize: number, totalCount: number) => {
        const newData = [...data];
        newData.map((item: any) => {
            if (item.clrNumber && item.documentNumber && item.documentNumber.indexOf('/') === -1) {
                item.documentNumber = `${item.documentNumber}/${item.clrNumber}`
            }
            if (item.clrNumber && item.equipmentNumber && item.equipmentNumber.indexOf('/') === -1) {
                item.equipmentNumber = `${item.equipmentNumber}/${item.clrNumber}`
            }
        })
        this.setState({
            page,
            pageSize,
            totalCount,
            isFetchinProgress: false,
            hasData: true,
            equipment: [...newData]
        })
    }
    private linkAction = (url: string) => {
        return this.props.history.push(url);
    };
    private resetDates = () => {
        if (this.props.equipments && this.props.equipments.result.length > 0) {
            this.props.resetEquipments()
        }
        this.setState({
            sorted: [],
            page: 1,
            totalCount: 0,
            etaFrom: false,
            etdFrom: false,
            isFetchinProgress: true,
            equipment: [],
            shouldClear: true,
            clearFilters: true,
            hasData: false
        })
    };
    private targetFetch = (page: number = this.state.page, pageSize: number = this.state.pageSize) => {
        const tempPageSize: any = localStorage.getItem('pageSize-ListTable jobCosting-search-equipment') ?
        localStorage.getItem('pageSize-ListTable jobCosting-search-equipment') : pageSize
        this.setState({
            isFetchinProgress: true,
            pageSize: tempPageSize
        })
        this.props.fetchEquipments(page, tempPageSize, this.state.genericFilter)
    }
    private fetchReset = (page: number = this.state.page = 1, pageSize: number = 10) => {
        if (this.tableRef && this.tableRef.current && this.tableRef.current.querySelector('.-pageJump input')) {
            this.tableRef.current.querySelector('input[type=number]').value = 1
        }
        if (!this.state.clearFilters) {
            const p = this.state.page ? this.state.page : page;
            const pS = this.state.pageSize ? this.state.pageSize : pageSize;
            this.setState({
                page: p,
                pageSize: pS,
                isFetchinProgress: true
            });
            this.targetFetch(p, pS)
        }
    };
    private justFetch = (tableData: any) => {
        if (!this.state.isFetchinProgress) {
            let props = {
                page: this.state.page,
                pageSize: this.state.pageSize
            }
            if (tableData) {
                props = {
                    page: tableData.page + 1,
                    pageSize: tableData.pageSize
                }
                this.setState({ sorted: tableData.sorted });
                setSortForTable(tableData.sorted, this.props.setSort)
            } else if (this.state.sorted && this.state.sorted.length) {
                setSortForTable(this.state.sorted, this.props.setSort);
            }
            this.setState({
                page: props.page,
                pageSize: props.pageSize,
                isFetchinProgress: true
            });
            this.targetFetch(props.page, props.pageSize)
        }
        if (tableData) {
            this.setState({
                page: tableData.page + 1,
                pageSize: tableData.pageSize,
            })
        }
    };
}
const mapStateToProps = (state: IStore): IMapStateToProps => ({
    isFetchSearchDataLoading: state.equipments.isFetchDataLoading,
    isFetchSearchDataError: state.equipments.isFetchDataError,
    searchPendingError: state.equipments.detailsPendingError,
    equipments: state.equipments.equipments,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, Action>): IMapDispatchToProps => ({
    fetchEquipments: (pageNumber: number, pageSize: number, genericFilter: string) => dispatch(fetchEquipments(pageNumber, pageSize, genericFilter)),
    setSort: (sort: ISortModel) => dispatch(setSort(sort)),
    resetSort: () => dispatch(resetSort()),
    displayFilters: (hideFilters: boolean, target: string) => dispatch(displayFilters(hideFilters, target)),
    resetEquipments: () => dispatch(resetEquipments())
});
const __SearchE = connect<IMapStateToProps, IMapDispatchToProps, {}, IStore>(mapStateToProps, mapDispatchToProps)(_SearchEquipment);
export const SearchEquipment = withRouter(__SearchE);